import PropTypes from 'prop-types';
import {
  AIRLINES,
  NUMBER_OF_STOPS,
  ONE_DAY_STOPOVER,
  ONE_NIGHT_STOPOVER,
  SHORT_STOPOVER,
  TRAVEL_TIME,
  TRIP_0_ARRIVAL_TIME,
  TRIP_0_DEPARTURE_TIME,
  TRIP_1_ARRIVAL_TIME,
  TRIP_1_DEPARTURE_TIME,
  TRIP_2_ARRIVAL_TIME,
  TRIP_2_DEPARTURE_TIME,
  TRIP_3_ARRIVAL_TIME,
  TRIP_3_DEPARTURE_TIME,
  TRIP_4_ARRIVAL_TIME,
  TRIP_4_DEPARTURE_TIME,
  TWO_NIGHTS_STOPOVER,
} from '../../../constants/searchFiltersConstants';

export const SelectedFilters = PropTypes.shape({
  [AIRLINES]: PropTypes.arrayOf(PropTypes.string),
  [NUMBER_OF_STOPS]: PropTypes.string,
  [ONE_DAY_STOPOVER]: PropTypes.bool,
  [ONE_NIGHT_STOPOVER]: PropTypes.bool,
  [SHORT_STOPOVER]: PropTypes.bool,
  [TRAVEL_TIME]: PropTypes.number,
  [TRIP_0_ARRIVAL_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_0_DEPARTURE_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_1_ARRIVAL_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_1_DEPARTURE_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_2_ARRIVAL_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_2_DEPARTURE_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_3_ARRIVAL_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_3_DEPARTURE_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_4_ARRIVAL_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TRIP_4_DEPARTURE_TIME]: PropTypes.shape({
    max: PropTypes.number,
    min: PropTypes.number,
  }),
  [TWO_NIGHTS_STOPOVER]: PropTypes.bool,
});
